// React
import React, { useState, useEffect } from "react";

export default function CommonsModal({ history }) {
  return (
    <>
      <section className="registerContainer">
        <div
          className="input--label"
          style={{
            textAlign: "center",
          }}
        >
          <label
            style={{
              fontWeight: "bold",
              color: "#e2dfcf",
              fontSize: "x-large",
              textAlign: "center",
            }}
          >
            NoWastedDays: A Digital Commons Project.
          </label>
        </div>
        {/* <img
          className="sticker"
          src="https://cdn.sanity.io/images/ou6d2gec/production/088a4919740e18a8e075aea3319a06cbe5dfba5d-4500x4500.png"
          width="25%"
          alt="daily planner"
          loading="lazy"
        /> */}
        <form className="register form">
          <div className={"yeartile--day"}>
            <div className={"input--label"}>
              <div className="iconDiv--day">
                <label htmlFor="thankYou" className="score label">
                  What does that mean?
                </label>
              </div>
            </div>
            <span className="commons--span">
              A commons is a responsibly managed, responsibly used shared
              resource. It is an idea that formally dates back over 1000 years
              about how things can improve the livelihoods of people both now
              and in the future, but exists in essence since the earliest tribes
              and social gatherings.
            </span>
          </div>

          <div className={"yeartile--day"}>
            <div className={"input--label"}>
              <div className="iconDiv--day">
                <label htmlFor="thankYou" className="score label">
                  What does that mean for me?
                </label>
              </div>
            </div>
            <span className="commons--span">
              It means you will be able to use NoWastedDays at no cost.
            </span>
          </div>

          <div className={"yeartile--day"}>
            <div className={"input--label"}>
              <div className="iconDiv--day">
                <label htmlFor="thankYou" className="score label">
                  Ok, that's great but what's the catch?
                </label>
              </div>
            </div>
            <p className="commons--span">
              There is no catch, simply a different way of thinking.
            </p>
            <p className="commons--span">
              Don't see this as an app, or a website, see it as a 'commons' i.e.
              a resource you are using and sharing with other people that is, in
              turn, being responsibly managed by a steward that has your
              interests and wellbeing in mind.
            </p>
          </div>

          <div className={"yeartile--day"}>
            <div className={"input--label"}>
              <div className="iconDiv--day">
                <label htmlFor="thankYou" className="score label">
                  Cool, but that doesn't sound very interesting, innovative or
                  important.
                </label>
              </div>
            </div>
            <p className="commons--span">
              By thinking and building this way, I believe we can deliver more
              technology into the world that avoids the individual and societal
              costs of it of which we are all too familiar. If you want to dive
              into this more, check this out.
            </p>
          </div>

          <div className={"yeartile--day"}>
            <div className={"input--label"}>
              <div className="iconDiv--day">
                <label htmlFor="thankYou" className="score label">
                  How can I support the digital commons?
                </label>
              </div>
            </div>
            <span className="commons--span">
              In 3 ways:
              <ul>
                <li>
                  Use it to help yourself: That is what it is designed to do!
                  Learn exactly how <a href="/about-nowasteddays">here</a>.
                </li>
                <li>
                  {" "}
                  <a href="/donate">Donate</a> so it can help other people in
                  the same way it can hopefully help you.
                </li>
                .
                <li>
                  If it doesn't help, <a href="/contact">request</a> that your
                  account is deleted, provide a bit of feedback and create space
                  for other people.
                </li>
              </ul>
            </span>
          </div>

          <div className="demographic__row--row">
            <a href="/digital-commons-project">
              <div
                className="registerButton"
                style={{
                  backgroundColor: "#e2dcfc",
                  border: "2px solid #004a22",
                }}
              >
                Learn More
              </div>
            </a>
            <a href="/tutorial/today">
              <div
                className="registerButton"
                style={{
                  backgroundColor: "#e2dcfc",
                  border: "2px solid #004a22",
                }}
              >
                Explore the Tutorial
              </div>
            </a>
            <a href="/today">
              <div className="registerButton">
                Just crack on and start your first journal day
              </div>
            </a>
          </div>
        </form>
      </section>
    </>
  );
}
